var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { CustomColumnType, InternalTagType, RollupType, TagType, } from '@common/api';
import * as baobab from '@data/baobab/baobab';
import { cellsApi, evaluatorApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { getTimeDimensionName } from '@data/tag/tagUtil';
import { CustomColumnType as TagCostumColumnType, isDimensionTagJsonData, isTableTagJsonData, } from '@data/tag/types';
import { ModelColumns, modelColumnsMeta, modelDiffVersionsFormat, Period } from '@util/enums';
import { parseInterval } from '@util/helpers';
import { handleApiErrorMessage } from '../../util/message';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { useEffect, useMemo, useRef, useState } from 'react';
import { createSheetRowExpression, createSheetRowName, getWithDataCompoundExpression, getFilterCompoundExpression, SheetRowPath, getSearchNumberColumnsData, } from '../sheetRow/sheetRow';
import { useSheetRowBranch, useSheetRowsById } from '../sheetRow/sheetRowHooks';
import { useActiveYears } from './timePoints';
import { useAuth } from '../../providers/AuthProvider';
import { useShownVersions } from './versions';
import { useLocalData } from '../../base/LocalDataContext';
var LastPromise = /** @class */ (function () {
    function LastPromise() {
        this.promises = [];
        this.pendingPromise = false;
        this.workingOnPromise = false;
    }
    LastPromise.prototype.pushPromise = function (promise) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.promises.push({
                promise: promise,
                resolve: resolve,
                reject: reject,
            });
            _this.handlePromises();
        });
    };
    LastPromise.prototype.handlePromises = function () {
        var e_1, _a;
        var _this = this;
        if (this.workingOnPromise) {
            return false;
        }
        var item = this.promises.pop();
        try {
            for (var _b = __values(this.promises), _c = _b.next(); !_c.done; _c = _b.next()) {
                var it = _c.value;
                it.resolve(null);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.promises.length = 0;
        if (!item) {
            return false;
        }
        try {
            this.workingOnPromise = true;
            item.promise()
                .then(function (value) {
                _this.workingOnPromise = false;
                item.resolve(value);
                _this.handlePromises();
            })
                .catch(function (err) {
                _this.workingOnPromise = false;
                item.reject(err);
                _this.handlePromises();
            });
        }
        catch (err) {
            this.workingOnPromise = false;
            item.reject(err);
            this.handlePromises();
        }
        return true;
    };
    return LastPromise;
}());
export { LastPromise };
var EvaluateLast = new LastPromise();
function useDebounce(value, delay) {
    var _a = __read(useState(value), 2), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var lastUpdateTime = useRef(0);
    useEffect(function () {
        var now = Date.now();
        if (now - lastUpdateTime.current > delay) {
            setDebouncedValue(value);
            lastUpdateTime.current = now;
        }
        else {
            var handler_1 = setTimeout(function () {
                setDebouncedValue(value);
            }, delay);
            return function () {
                clearTimeout(handler_1);
            };
        }
    }, [value, delay]);
    return debouncedValue;
}
function mapDifference(firstMap, secondMap) {
    var e_2, _a;
    var newMap = new Map();
    try {
        for (var firstMap_1 = __values(firstMap), firstMap_1_1 = firstMap_1.next(); !firstMap_1_1.done; firstMap_1_1 = firstMap_1.next()) {
            var _b = __read(firstMap_1_1.value, 2), k = _b[0], v = _b[1];
            if (!secondMap.has(k)) {
                newMap.set(k, v);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (firstMap_1_1 && !firstMap_1_1.done && (_a = firstMap_1.return)) _a.call(firstMap_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return newMap;
}
function defaultRowHeaderGenerator(sheetRows, shownVersions, selectedSheetRowPath, filterTagIds) {
    var e_3, _a, e_4, _b;
    var _c, _d;
    var result = [];
    try {
        for (var sheetRows_1 = __values(sheetRows), sheetRows_1_1 = sheetRows_1.next(); !sheetRows_1_1.done; sheetRows_1_1 = sheetRows_1.next()) {
            var sheetRow = sheetRows_1_1.value;
            var selected = sheetRow.path === selectedSheetRowPath;
            var tagName = (_d = (_c = sheetRow.generatedTag) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
            try {
                for (var shownVersions_1 = (e_4 = void 0, __values(shownVersions)), shownVersions_1_1 = shownVersions_1.next(); !shownVersions_1_1.done; shownVersions_1_1 = shownVersions_1.next()) {
                    var version = shownVersions_1_1.value;
                    var dataExpression = createSheetRowExpression(sheetRow, filterTagIds, { version: version });
                    result.push({
                        depth: sheetRow.depth,
                        expanded: sheetRow.expanded,
                        dataString: dataExpression,
                        canExpand: sheetRow.hasChildren && sheetRow.depth > 0,
                        object: sheetRow,
                        readonly: sheetRow.sheetRow.readonly,
                        selected: selected,
                        tagDesc: sheetRow.tagDescription,
                        tagName: tagName,
                        title: createSheetRowName(sheetRow, { version: version }),
                        version: version,
                    });
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (shownVersions_1_1 && !shownVersions_1_1.done && (_b = shownVersions_1.return)) _b.call(shownVersions_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (sheetRows_1_1 && !sheetRows_1_1.done && (_a = sheetRows_1.return)) _a.call(sheetRows_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return result;
}
function stackedRowHeaderGenerator(sheetRows, activeYears, shownVersions, selectedSheetRowPath, yearDimensions, filterTagIds) {
    var e_5, _a, e_6, _b;
    var _c, _d;
    var result = [];
    try {
        for (var sheetRows_2 = __values(sheetRows), sheetRows_2_1 = sheetRows_2.next(); !sheetRows_2_1.done; sheetRows_2_1 = sheetRows_2.next()) {
            var sheetRow = sheetRows_2_1.value;
            var selected = sheetRow.path === selectedSheetRowPath;
            var tagName = (_d = (_c = sheetRow.generatedTag) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
            var _loop_1 = function (y) {
                var e_7, _e;
                var yearDimension = yearDimensions.find(function (t) { return t.order === y; });
                if (!yearDimension) {
                    return "continue";
                }
                try {
                    for (var shownVersions_2 = (e_7 = void 0, __values(shownVersions)), shownVersions_2_1 = shownVersions_2.next(); !shownVersions_2_1.done; shownVersions_2_1 = shownVersions_2.next()) {
                        var version = shownVersions_2_1.value;
                        var dataExpression = createSheetRowExpression(sheetRow, filterTagIds, {
                            version: version,
                            year: yearDimension,
                        });
                        result.push({
                            depth: sheetRow.depth,
                            expanded: sheetRow.expanded,
                            dataString: dataExpression,
                            canExpand: sheetRow.hasChildren && sheetRow.depth > 0,
                            object: sheetRow,
                            readonly: sheetRow.sheetRow.readonly,
                            selected: selected,
                            tagDesc: sheetRow.tagDescription,
                            tagName: tagName,
                            title: createSheetRowName(sheetRow, { version: version, year: yearDimension }),
                            version: version,
                        });
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (shownVersions_2_1 && !shownVersions_2_1.done && (_e = shownVersions_2.return)) _e.call(shownVersions_2);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            };
            try {
                for (var activeYears_1 = (e_6 = void 0, __values(activeYears)), activeYears_1_1 = activeYears_1.next(); !activeYears_1_1.done; activeYears_1_1 = activeYears_1.next()) {
                    var y = activeYears_1_1.value;
                    _loop_1(y);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (activeYears_1_1 && !activeYears_1_1.done && (_b = activeYears_1.return)) _b.call(activeYears_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (sheetRows_2_1 && !sheetRows_2_1.done && (_a = sheetRows_2.return)) _a.call(sheetRows_2);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return result;
}
function comparisonsRowHeaderGenerator(sheetRows, selectedSheetRowPath, filterTagIds) {
    var e_8, _a;
    var _b, _c;
    var result = [];
    try {
        for (var sheetRows_3 = __values(sheetRows), sheetRows_3_1 = sheetRows_3.next(); !sheetRows_3_1.done; sheetRows_3_1 = sheetRows_3.next()) {
            var sheetRow = sheetRows_3_1.value;
            var selected = sheetRow.path === selectedSheetRowPath;
            var tagName = (_c = (_b = sheetRow.generatedTag) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '';
            var dataExpression = createSheetRowExpression(sheetRow, filterTagIds);
            result.push({
                title: createSheetRowName(sheetRow),
                dataString: dataExpression,
                depth: sheetRow.depth,
                object: sheetRow,
                tagDesc: sheetRow.tagDescription,
                tagName: tagName || '',
                canExpand: sheetRow.hasChildren && sheetRow.depth > 0,
                expanded: sheetRow.expanded,
                selected: selected,
                readonly: sheetRow.sheetRow.readonly,
            });
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (sheetRows_3_1 && !sheetRows_3_1.done && (_a = sheetRows_3.return)) _a.call(sheetRows_3);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return result;
}
function stackedWithComparisonsRowHeaderGenerator(sheetRows, activeYears, activeVersions, selectedSheetRowPath, yearDimensions, versionsByYear, comparisons, startYear, endYear, diffFormat, filterTagIds) {
    var e_9, _a, e_10, _b;
    var _c, _d, _e, _f, _g;
    var result = [];
    var versionsById = {};
    activeVersions.reduce(function (map, version) {
        map[version.id] = version;
        return map;
    }, versionsById);
    try {
        for (var sheetRows_4 = __values(sheetRows), sheetRows_4_1 = sheetRows_4.next(); !sheetRows_4_1.done; sheetRows_4_1 = sheetRows_4.next()) {
            var sheetRow = sheetRows_4_1.value;
            var selected = sheetRow.path === selectedSheetRowPath;
            var tagName = (_d = (_c = sheetRow.generatedTag) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
            var _loop_2 = function (year) {
                var e_11, _h, e_12, _j, e_13, _k, e_14, _l;
                if (year < startYear || year > endYear) {
                    return "continue";
                }
                var filteredComparisons = [];
                try {
                    for (var comparisons_1 = (e_11 = void 0, __values(comparisons)), comparisons_1_1 = comparisons_1.next(); !comparisons_1_1.done; comparisons_1_1 = comparisons_1.next()) {
                        var comparison = comparisons_1_1.value;
                        var maxYear = Math.max(comparison.optionA.year, comparison.optionB.year);
                        var optionAExist = versionsByYear[comparison.optionA.year] &&
                            comparison.optionA.year >= startYear &&
                            comparison.optionA.year <= endYear &&
                            ((_e = versionsByYear[comparison.optionA.year]) === null || _e === void 0 ? void 0 : _e.includes(comparison.optionA.versionId));
                        var optionBExist = versionsByYear[comparison.optionB.year] &&
                            comparison.optionB.year >= startYear &&
                            comparison.optionB.year <= endYear &&
                            ((_f = versionsByYear[comparison.optionB.year]) === null || _f === void 0 ? void 0 : _f.includes(comparison.optionB.versionId));
                        if (maxYear === year && optionAExist && optionBExist) {
                            filteredComparisons.push(comparison);
                        }
                    }
                }
                catch (e_11_1) { e_11 = { error: e_11_1 }; }
                finally {
                    try {
                        if (comparisons_1_1 && !comparisons_1_1.done && (_h = comparisons_1.return)) _h.call(comparisons_1);
                    }
                    finally { if (e_11) throw e_11.error; }
                }
                var yearVersions = (_g = versionsByYear[year]) !== null && _g !== void 0 ? _g : [];
                var yearDimension = yearDimensions.find(function (y) { return y.order === year; });
                try {
                    for (var yearVersions_1 = (e_12 = void 0, __values(yearVersions)), yearVersions_1_1 = yearVersions_1.next(); !yearVersions_1_1.done; yearVersions_1_1 = yearVersions_1.next()) {
                        var versionId = yearVersions_1_1.value;
                        var version = versionsById[versionId];
                        var dataExpression = createSheetRowExpression(sheetRow, filterTagIds, {
                            version: version,
                            year: yearDimension,
                        });
                        result.push({
                            dataString: dataExpression,
                            title: createSheetRowName(sheetRow, { year: yearDimension, version: version }),
                            depth: sheetRow.depth,
                            object: sheetRow,
                            tagDesc: sheetRow.tagDescription,
                            tagName: tagName,
                            canExpand: sheetRow.hasChildren && sheetRow.depth > 0,
                            expanded: sheetRow.expanded,
                            selected: selected,
                            readonly: sheetRow.sheetRow.readonly,
                        });
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (yearVersions_1_1 && !yearVersions_1_1.done && (_j = yearVersions_1.return)) _j.call(yearVersions_1);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
                try {
                    for (var filteredComparisons_1 = (e_13 = void 0, __values(filteredComparisons)), filteredComparisons_1_1 = filteredComparisons_1.next(); !filteredComparisons_1_1.done; filteredComparisons_1_1 = filteredComparisons_1.next()) {
                        var comparison = filteredComparisons_1_1.value;
                        var cy = Math.max(comparison.optionA.year, comparison.optionB.year);
                        if (cy !== year)
                            continue;
                        var comparisonData = getComparisonDataArray(comparison, yearDimensions, diffFormat, activeVersions, sheetRow.allTags.map(function (t) { return t.id; }));
                        try {
                            for (var comparisonData_1 = (e_14 = void 0, __values(comparisonData)), comparisonData_1_1 = comparisonData_1.next(); !comparisonData_1_1.done; comparisonData_1_1 = comparisonData_1.next()) {
                                var cd = comparisonData_1_1.value;
                                result.push(__assign(__assign({}, cd), { title: "".concat(createSheetRowName(sheetRow), " (").concat(cd.title, ")"), depth: sheetRow.depth, object: sheetRow, tagDesc: sheetRow.tagDescription, tagName: tagName, canExpand: false, expanded: false, selected: selected, readonly: sheetRow.sheetRow.readonly }));
                            }
                        }
                        catch (e_14_1) { e_14 = { error: e_14_1 }; }
                        finally {
                            try {
                                if (comparisonData_1_1 && !comparisonData_1_1.done && (_l = comparisonData_1.return)) _l.call(comparisonData_1);
                            }
                            finally { if (e_14) throw e_14.error; }
                        }
                    }
                }
                catch (e_13_1) { e_13 = { error: e_13_1 }; }
                finally {
                    try {
                        if (filteredComparisons_1_1 && !filteredComparisons_1_1.done && (_k = filteredComparisons_1.return)) _k.call(filteredComparisons_1);
                    }
                    finally { if (e_13) throw e_13.error; }
                }
            };
            try {
                for (var activeYears_2 = (e_10 = void 0, __values(activeYears)), activeYears_2_1 = activeYears_2.next(); !activeYears_2_1.done; activeYears_2_1 = activeYears_2.next()) {
                    var year = activeYears_2_1.value;
                    _loop_2(year);
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (activeYears_2_1 && !activeYears_2_1.done && (_b = activeYears_2.return)) _b.call(activeYears_2);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
    }
    catch (e_9_1) { e_9 = { error: e_9_1 }; }
    finally {
        try {
            if (sheetRows_4_1 && !sheetRows_4_1.done && (_a = sheetRows_4.return)) _a.call(sheetRows_4);
        }
        finally { if (e_9) throw e_9.error; }
    }
    return result;
}
export default function useModelTable(rootRow, selectedRow, activeVersions) {
    var _this = this;
    var _a, _b, _c, _d;
    var _e = __read(useState(null), 2), data = _e[0], setData = _e[1];
    var _f = __read(useState(null), 2), lastFetched = _f[0], setLastFetched = _f[1];
    var _g = __read(useState(''), 2), currentDataKey = _g[0], setCurrentDataKey = _g[1];
    var _h = __read(useState(0), 2), invalidator = _h[0], setInvalidator = _h[1];
    var _j = __read(useState(new Map()), 2), cellUpdatesInProgress = _j[0], setCellUpdatesInProgress = _j[1];
    var activeYears = useActiveYears();
    var debouncedInvalidator = useDebounce(invalidator, 1000);
    var sheetRowMap = useSheetRowsById();
    var userSettings = useAuth().settings;
    var tagData = useTagContext().tagData;
    var formatLocaleDate = useLanguage().formatLocaleDate;
    var _k = useLocalData(), filterTagIds = _k.filterTagIds, withDataMap = _k.withDataMap;
    var forecastErrors = useBranch({
        forecastErrors: ['models', 'forecastErrors'],
    }).forecastErrors;
    var intervalStart = userSettings.model_table_interval_start;
    var intervalEnd = userSettings.model_table_interval_end;
    var _l = parseInterval(intervalStart, intervalEnd, activeYears), startYear = _l.startYear, endYear = _l.endYear;
    var periods = userSettings.model_table_periods;
    var showSum = userSettings.model_table_show_sum;
    var versionsByYear = userSettings.model_table_timeline_versions_by_year;
    var isStacked = userSettings.model_table_stacked;
    var isCustomDataDisplay = Object.keys(versionsByYear).length !== 0;
    var comparisons = userSettings.model_table_timeline_comparisons;
    var diffFormat = userSettings.model_table_timeline_diffformat;
    var filteredVersionIds = userSettings.model_table_filtered_versions;
    var infoColumns = userSettings.model_table_columns;
    var modelSort = userSettings.model_table_sort;
    var customCols = (_a = rootRow === null || rootRow === void 0 ? void 0 : rootRow.sheetRow.customColumns) !== null && _a !== void 0 ? _a : [];
    var monthTags = tagData.internalTagsMap.months;
    var quarterTags = tagData.internalTagsMap.quarters;
    var hyTags = tagData.internalTagsMap.halfYears;
    var yearTags = tagData.internalTagsMap.years;
    var ytdTags = tagData.internalTagsMap.yearToDate;
    var shownVersions = useShownVersions(userSettings);
    var numberColumnsData = [];
    var columnHeaders = [];
    var customColumnHeaders = [];
    var rowStrings = [];
    var colStrings = [];
    var key = '';
    if ((monthTags === null || monthTags === void 0 ? void 0 : monthTags.length) > 0 && (quarterTags === null || quarterTags === void 0 ? void 0 : quarterTags.length) > 0 && (hyTags === null || hyTags === void 0 ? void 0 : hyTags.length) > 0 && (yearTags === null || yearTags === void 0 ? void 0 : yearTags.length) > 0) {
        var chs = generateModelTableColumns(intervalStart, intervalEnd, periods, showSum, versionsByYear, isStacked, isCustomDataDisplay, comparisons, diffFormat, activeVersions, activeYears, monthTags, quarterTags, hyTags, yearTags, ytdTags);
        var colDataStrings = chs.map(function (ch) { return ch.dataString; });
        var cchs = generateCustomColumns(customCols, tagData.tagById, tagData.tagsByParentId, isCustomDataDisplay, filteredVersionIds, activeVersions);
        numberColumnsData = (_b = getSearchNumberColumnsData(rootRow === null || rootRow === void 0 ? void 0 : rootRow.sheetRow)) !== null && _b !== void 0 ? _b : [];
        columnHeaders = __spreadArray(__spreadArray([], __read(cchs), false), __read(chs), false);
        customColumnHeaders = cchs;
        var customColDataStrings = cchs.map(function (ch) { return ch.dataString; });
        var allColDataStrings = __spreadArray(__spreadArray([], __read(customColDataStrings), false), __read(colDataStrings), false);
        colStrings = allColDataStrings;
    }
    var withDataCompoundExpression = getWithDataCompoundExpression(versionsByYear, {
        start: userSettings.model_table_interval_start,
        end: userSettings.model_table_interval_end,
    }, activeYears, tagData.tagById, tagData.internalTagsMap, shownVersions, activeVersions);
    var filterCompoundExpression = getFilterCompoundExpression(filterTagIds, tagData.tagById);
    var selectedSheetRowPath = (_c = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.path) !== null && _c !== void 0 ? _c : '0';
    var _m = __read(useSheetRowBranch(new SheetRowPath((_d = rootRow === null || rootRow === void 0 ? void 0 : rootRow.path) !== null && _d !== void 0 ? _d : '0'), tagData.tagById, sheetRowMap, userSettings.expanded_clusters, {
        withDataCompoundExpression: withDataCompoundExpression,
        filterCompoundExpression: filterCompoundExpression,
    }, withDataMap, numberColumnsData), 1), sheetRows = _m[0];
    var rowHeaders = [];
    if (isCustomDataDisplay && isStacked) {
        rowHeaders = stackedWithComparisonsRowHeaderGenerator(sheetRows, activeYears, activeVersions, selectedSheetRowPath, yearTags, versionsByYear, comparisons, startYear, endYear, diffFormat, filterTagIds);
    }
    else if (isStacked) {
        rowHeaders = stackedRowHeaderGenerator(sheetRows, activeYears, shownVersions, selectedSheetRowPath, yearTags, filterTagIds);
    }
    else if (isCustomDataDisplay) {
        rowHeaders = comparisonsRowHeaderGenerator(sheetRows, selectedSheetRowPath, filterTagIds);
    }
    else {
        rowHeaders = defaultRowHeaderGenerator(sheetRows, shownVersions, selectedSheetRowPath, filterTagIds);
    }
    var rowDataStrings = rowHeaders.map(function (r) { return r.dataString; });
    rowStrings = rowDataStrings;
    key = rowDataStrings.join(',') + colStrings.join(',');
    var fetch = function (rs, cs) { return __awaiter(_this, void 0, void 0, function () {
        var res, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    baobab.root.select(['state', 'loadingInProgress']).set(true);
                    return [4 /*yield*/, EvaluateLast.pushPromise(function () { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, evaluatorApi.evaluate({
                                            rows: rs,
                                            cols: cs,
                                        })];
                                    case 1:
                                        data = _a.sent();
                                        return [2 /*return*/, {
                                                key: key,
                                                data: data,
                                            }];
                                }
                            });
                        }); })];
                case 1:
                    res = _a.sent();
                    setLastFetched(res);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    handleApiErrorMessage(error_1, 'Failed to evaluate cells. ');
                    return [3 /*break*/, 4];
                case 3:
                    baobab.root.select(['state', 'loadingInProgress']).set(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(rowStrings.length > 0 && colStrings.length > 0)) return [3 /*break*/, 2];
                        if (key !== currentDataKey && data !== null) {
                            setData(null);
                        }
                        // rowStrings and colStrings should already be refreshed if key has changed
                        return [4 /*yield*/, fetch(rowStrings, colStrings)];
                    case 1:
                        // rowStrings and colStrings should already be refreshed if key has changed
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [key, debouncedInvalidator]);
    useEffect(function () {
        if (lastFetched && lastFetched.data && key === (lastFetched === null || lastFetched === void 0 ? void 0 : lastFetched.key)) {
            setCurrentDataKey(lastFetched.key);
            setData(lastFetched.data);
        }
    }, [lastFetched]);
    var invalidate = function () {
        setInvalidator(function (inv) { return inv + 1; });
    };
    var update = function (changes) { return __awaiter(_this, void 0, void 0, function () {
        var updateCellValueRequests, newCellDescriptors, changes_1, changes_1_1, change, error_2;
        var e_15, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updateCellValueRequests = [];
                    newCellDescriptors = new Map();
                    try {
                        for (changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
                            change = changes_1_1.value;
                            updateCellValueRequests.push({
                                id: change.id,
                                value: change.value,
                                tagIds: change.tagIds,
                            });
                            newCellDescriptors.set(change.tagIds.join(','), change.value);
                        }
                    }
                    catch (e_15_1) { e_15 = { error: e_15_1 }; }
                    finally {
                        try {
                            if (changes_1_1 && !changes_1_1.done && (_a = changes_1.return)) _a.call(changes_1);
                        }
                        finally { if (e_15) throw e_15.error; }
                    }
                    setCellUpdatesInProgress(function (old) { return new Map(__spreadArray(__spreadArray([], __read(old), false), __read(newCellDescriptors), false)); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    if (!(updateCellValueRequests.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, cellsApi.updateBatch(updateCellValueRequests)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    handleApiErrorMessage(error_2, 'Failed to update cells: ');
                    return [3 /*break*/, 5];
                case 5:
                    if (!(rowStrings.length > 0 || colStrings.length > 0)) return [3 /*break*/, 7];
                    return [4 /*yield*/, fetch(rowStrings, colStrings)];
                case 6:
                    _b.sent();
                    setCellUpdatesInProgress(function (old) { return mapDifference(old, newCellDescriptors); });
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var tagColumnsData = getTagColumnsData(customColumnHeaders, rowHeaders, tagData, formatLocaleDate);
    var modelTableRows = rowHeaders
        ? getTableRows(rowHeaders, data, tagColumnsData, cellUpdatesInProgress, forecastErrors, tagData.tagById)
        : [];
    var modelTableColumnHeaders = columnHeaders ? __spreadArray(__spreadArray([], __read(getExtraColumns(infoColumns)), false), __read(columnHeaders), false) : [];
    // sort
    var sortedRows = useMemo(function () {
        var sortByColDataIdx = null;
        if (modelSort && modelSort.col) {
            var findColIdx = modelTableColumnHeaders.findIndex(function (mtch) { return mtch.title === modelSort.col.title; });
            sortByColDataIdx = findColIdx - 1 - infoColumns.length;
        }
        return modelSort && sortByColDataIdx !== null
            ? sortTableRows(sortByColDataIdx, modelSort.col, isCustomDataDisplay ? null : modelSort.versionId, modelSort.asc, modelTableRows)
            : modelTableRows;
    }, [modelSort, modelTableColumnHeaders, infoColumns, modelTableRows]);
    return {
        modelTable: {
            initialLoad: lastFetched === null,
            rows: sortedRows,
            columnHeaders: modelTableColumnHeaders,
        },
        update: update,
        invalidate: invalidate,
    };
}
export function getExtraColumns(infoColumns) {
    var extraColumns = [];
    extraColumns.push({
        dataString: '',
        title: 'Title',
        type: ModelColumns.TITLE,
    });
    infoColumns.forEach(function (ic) {
        var mcmeta = modelColumnsMeta.find(function (mc) { return mc.value === ic; });
        extraColumns.push({
            dataString: '',
            title: (mcmeta === null || mcmeta === void 0 ? void 0 : mcmeta.label) || '',
            type: (mcmeta === null || mcmeta === void 0 ? void 0 : mcmeta.value) || ModelColumns.TITLE,
        });
    });
    return extraColumns;
}
function getTagColumnsData(tagColumnsHeaders, rowHeaders, tagData, formatLocaleDate) {
    var e_16, _a, e_17, _b;
    var tagsColsData = [];
    try {
        for (var rowHeaders_1 = __values(rowHeaders), rowHeaders_1_1 = rowHeaders_1.next(); !rowHeaders_1_1.done; rowHeaders_1_1 = rowHeaders_1.next()) {
            var row = rowHeaders_1_1.value;
            var rowCells = [];
            var genTagId = row.object.generatedTagId ? row.object.generatedTagId : null;
            var genTag = tagData.tagById[genTagId || 0];
            var _loop_3 = function (header) {
                var e_18, _c, e_19, _d;
                if (!header.tagId) {
                    rowCells.push(null);
                    return "continue";
                }
                var tagCustomValues = {};
                if (header.type !== ModelColumns.TAGS &&
                    genTag &&
                    genTag.jsonData !== null &&
                    isDimensionTagJsonData(genTag.jsonData)) {
                    tagCustomValues = genTag.jsonData.values;
                }
                if (header.type === ModelColumns.NUMBER_PROPERTY ||
                    header.type === ModelColumns.TEXT_PROPERTY ||
                    header.type === ModelColumns.DATE_PROPERTY ||
                    header.type === ModelColumns.FILE_PROPERTY) {
                    var propertyCell = {
                        tagId: null,
                        tagName: '',
                        parentTagId: header.tagId,
                        readonly: (genTag === null || genTag === void 0 ? void 0 : genTag.ParentId) !== header.tagId,
                        value: null,
                        propertyValue: null,
                        tagIds: [],
                        loading: false,
                        position: { x: 0, y: 0 },
                    };
                    var value = tagCustomValues[header.dataString] ? tagCustomValues[header.dataString] : null;
                    if (header.type === ModelColumns.NUMBER_PROPERTY) {
                        propertyCell.value = typeof value === 'number' ? value : null;
                    }
                    else if (header.type === ModelColumns.TEXT_PROPERTY) {
                        propertyCell.propertyValue = typeof value === 'string' ? value : '';
                    }
                    else if (header.type === ModelColumns.DATE_PROPERTY) {
                        propertyCell.propertyValue = typeof value === 'string' ? formatLocaleDate(new Date(value)) : '';
                    }
                    else if (header.type === ModelColumns.FILE_PROPERTY) {
                        propertyCell.propertyValue = value && typeof value === 'object' ? value.filename || '' : null;
                    }
                    rowCells.push(propertyCell);
                    return "continue";
                }
                var tagCell = {
                    tagId: null,
                    tagName: '',
                    parentTagId: header.tagId,
                    readonly: false,
                    value: null,
                    tagIds: [],
                    loading: false,
                    position: { x: 0, y: 0 },
                };
                if (genTag) {
                    // if genTag is set, the cluster is GENERATED
                    // first check if the header tag is connected to genTag
                    // in that case the user sees and can change the genTag's connection
                    var relation = tagData.relationByKey.get("".concat(genTag.ParentId, "-").concat(header.tagId));
                    if (relation) {
                        var connections = tagData.relationConnectionsByKey.get("".concat(genTag.ParentId, "-").concat(header.tagId, "-").concat(genTag.id));
                        if (connections && connections.length > 0) {
                            var names_1 = [];
                            try {
                                for (var connections_1 = (e_18 = void 0, __values(connections)), connections_1_1 = connections_1.next(); !connections_1_1.done; connections_1_1 = connections_1.next()) {
                                    var conn = connections_1_1.value;
                                    var connectedTag = tagData.tagById[conn.connectedDimensionTagId];
                                    if (connectedTag) {
                                        names_1.push(connectedTag.name);
                                    }
                                }
                            }
                            catch (e_18_1) { e_18 = { error: e_18_1 }; }
                            finally {
                                try {
                                    if (connections_1_1 && !connections_1_1.done && (_c = connections_1.return)) _c.call(connections_1);
                                }
                                finally { if (e_18) throw e_18.error; }
                            }
                            if (connections.length === 1) {
                                tagCell.tagId = connections[0].connectedDimensionTagId;
                                tagCell.readonly = false;
                            }
                            else {
                                tagCell.readonly = true;
                            }
                            tagCell.tagName = names_1.join(',');
                        }
                        rowCells.push(tagCell);
                        return "continue";
                    }
                }
                // if unable to find the connected tag, user sees the tags attached on cluster
                // and can change them, but only if:
                // a) the tag is attached directly on a cluster (not inherited)
                // AND
                // b) and there is only one tag attached of same table
                // AND
                // c) and the cluster is NOT generated
                var tagInfos = row.object.allTags.filter(function (t) { return (header.tagsChildrenTagIds || []).includes(t.id); });
                var names = [];
                try {
                    for (var tagInfos_1 = (e_19 = void 0, __values(tagInfos)), tagInfos_1_1 = tagInfos_1.next(); !tagInfos_1_1.done; tagInfos_1_1 = tagInfos_1.next()) {
                        var tagInfo = tagInfos_1_1.value;
                        var tag = tagData.tagById[tagInfo.id];
                        if (tag) {
                            names.push(tag.name);
                        }
                    }
                }
                catch (e_19_1) { e_19 = { error: e_19_1 }; }
                finally {
                    try {
                        if (tagInfos_1_1 && !tagInfos_1_1.done && (_d = tagInfos_1.return)) _d.call(tagInfos_1);
                    }
                    finally { if (e_19) throw e_19.error; }
                }
                if (tagInfos.length === 1) {
                    tagCell.tagId = tagInfos[0].id;
                    tagCell.readonly = tagInfos[0].inherited || genTag !== undefined;
                }
                else {
                    tagCell.readonly = true;
                }
                tagCell.tagName = names.join(',');
                rowCells.push(tagCell);
            };
            try {
                for (var tagColumnsHeaders_1 = (e_17 = void 0, __values(tagColumnsHeaders)), tagColumnsHeaders_1_1 = tagColumnsHeaders_1.next(); !tagColumnsHeaders_1_1.done; tagColumnsHeaders_1_1 = tagColumnsHeaders_1.next()) {
                    var header = tagColumnsHeaders_1_1.value;
                    _loop_3(header);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (tagColumnsHeaders_1_1 && !tagColumnsHeaders_1_1.done && (_b = tagColumnsHeaders_1.return)) _b.call(tagColumnsHeaders_1);
                }
                finally { if (e_17) throw e_17.error; }
            }
            tagsColsData.push(rowCells);
        }
    }
    catch (e_16_1) { e_16 = { error: e_16_1 }; }
    finally {
        try {
            if (rowHeaders_1_1 && !rowHeaders_1_1.done && (_a = rowHeaders_1.return)) _a.call(rowHeaders_1);
        }
        finally { if (e_16) throw e_16.error; }
    }
    return tagsColsData;
}
export function getVersionTagId(vId, versions) {
    var v = versions.find(function (v) { return v.id === vId; });
    return (v === null || v === void 0 ? void 0 : v.versionTagId) || 0;
}
function getDataString(arr) {
    arr.sort(function (a, b) {
        var aa = Array.isArray(a) ? a[0] : a;
        var bb = Array.isArray(b) ? b[0] : b;
        return aa - bb;
    });
    var tags = arr.map(function (item) {
        if (Array.isArray(item)) {
            return item.join('|');
        }
        else {
            return "".concat(item);
        }
    });
    return "tags(".concat(tags.join(','), ")");
}
function getComparisonDataArray(comparison, yearTags, diffFormat, versions, extraTagIds, prefix) {
    var _a;
    var _b, _c;
    if (prefix === void 0) { prefix = ''; }
    var a = comparison.optionA;
    var b = comparison.optionB;
    if (comparison.reverse) {
        _a = __read([b, a], 2), a = _a[0], b = _a[1];
    }
    var aVersionTagId = getVersionTagId(a.versionId, versions);
    var aYearTag = yearTags.find(function (y) { return y.name === "Y".concat(a.year); });
    var aString = getDataString(__spreadArray(__spreadArray([], __read(extraTagIds), false), [(_b = aYearTag === null || aYearTag === void 0 ? void 0 : aYearTag.id) !== null && _b !== void 0 ? _b : 0, aVersionTagId], false));
    var bVersionTagId = getVersionTagId(b.versionId, versions);
    var bYearTag = yearTags.find(function (y) { return y.name === "Y".concat(b.year); });
    var bString = getDataString(__spreadArray(__spreadArray([], __read(extraTagIds), false), [(_c = bYearTag === null || bYearTag === void 0 ? void 0 : bYearTag.id) !== null && _c !== void 0 ? _c : 0, bVersionTagId], false));
    return diffFormat.map(function (df) {
        switch (df) {
            case modelDiffVersionsFormat.PERCENT:
                return {
                    dataString: "100*(".concat(aString, "-").concat(bString, ")/").concat(bString),
                    title: "".concat(prefix).concat(a.title, " v. ").concat(prefix).concat(b.title, " %"),
                    type: ModelColumns.COMPARISON,
                };
            case modelDiffVersionsFormat.ABSOLUTE:
            default:
                return {
                    dataString: "".concat(aString, "-").concat(bString),
                    title: "".concat(prefix).concat(a.title, " v. ").concat(prefix).concat(b.title),
                    type: ModelColumns.COMPARISON,
                };
        }
    });
}
function createNumberCustomColumn(customColumn, tagById, idx, version) {
    var accountTagId = customColumn.accountTagId;
    var title = '';
    if (customColumn.name && customColumn.name !== '') {
        title = customColumn.name;
    }
    else {
        var nameTag = accountTagId ? tagById[accountTagId] : null;
        if (!nameTag) {
            var firstDimTagId = customColumn.dimensionTagIds ? customColumn.dimensionTagIds[0] : null;
            nameTag = firstDimTagId ? tagById[firstDimTagId] : null;
        }
        title = nameTag ? (version ? "".concat(nameTag.name, " (").concat(version.name, ")") : nameTag.name) : 'Custom Column';
    }
    var tagIds = [];
    if (accountTagId) {
        tagIds.push(accountTagId);
    }
    if (customColumn.dimensionTagIds) {
        tagIds = tagIds.concat(customColumn.dimensionTagIds);
    }
    return {
        isReadonly: customColumn.readonly,
        dataString: getDataString(version ? __spreadArray(__spreadArray([], __read(tagIds), false), [version.versionTagId], false) : tagIds),
        title: title,
        type: ModelColumns.CUSTOM_COL,
        customColIdx: idx,
        hasAccountTag: !!accountTagId,
        accountTagId: accountTagId !== null && accountTagId !== void 0 ? accountTagId : undefined,
    };
}
function createTableCustomColumn(tag, tagsByParentId, idx, readonly, customName) {
    var tagsChildrenTagIds = (tagsByParentId[tag.id] || []).map(function (tag) { return tag.id; });
    return {
        dataString: '',
        title: customName && customName !== '' ? customName : tag.name,
        type: ModelColumns.TAGS,
        tagId: tag.id,
        tagsChildrenTagIds: tagsChildrenTagIds,
        customColIdx: idx,
        isReadonly: readonly || false,
    };
}
function createPropertyCustomColumn(customColumn, tagById, idx) {
    if (!customColumn.property) {
        return;
    }
    var propertyIdString = customColumn.property;
    var tableId = customColumn.tableTagId;
    var header = null;
    var table = null;
    if (tableId && propertyIdString) {
        table = tagById[tableId];
        if (table && table.jsonData !== null && isTableTagJsonData(table.jsonData)) {
            header = table.jsonData.headers.find(function (h) { return h.uniqueId === propertyIdString; }) || null;
        }
    }
    if (!table || !header) {
        return;
    }
    var propertyCol = {
        dataString: header.uniqueId,
        title: customColumn.name && customColumn.name !== '' ? customColumn.name : header.name,
        type: ModelColumns.CUSTOM_COL,
        tagId: table.id,
        customColIdx: idx,
        isReadonly: customColumn === null || customColumn === void 0 ? void 0 : customColumn.readonly,
    };
    switch (header.type) {
        case TagCostumColumnType.NUMBER:
            propertyCol.type = ModelColumns.NUMBER_PROPERTY;
            break;
        case TagCostumColumnType.TEXT:
            propertyCol.type = ModelColumns.TEXT_PROPERTY;
            break;
        case TagCostumColumnType.DATE:
            propertyCol.type = ModelColumns.DATE_PROPERTY;
            break;
        case TagCostumColumnType.FILE:
            propertyCol.type = ModelColumns.FILE_PROPERTY;
            break;
    }
    return propertyCol;
}
export function generateCustomColumns(customColumns, tagById, tagsByParentId, isCustomDataDisplay, filteredVersionIds, activeVersions) {
    var e_20, _a;
    var _b, _c;
    var filteredVersions = filteredVersionIds
        .map(function (versionId) { return activeVersions.find(function (version) { return version.id === versionId; }); })
        .filter(function (versionOrUndefined) { return versionOrUndefined !== undefined; });
    var activeVersionsTagIds = activeVersions.map(function (v) { return v.versionTagId; });
    if (!isCustomDataDisplay || filteredVersions.length === 0) {
        // normal timeline or all versions are off -> return normal custom columns
        var cc_1 = [];
        customColumns.forEach(function (customColumn, idx) {
            var _a;
            if (customColumn.type === CustomColumnType.Table && customColumn.property !== undefined) {
                var propertyCol = createPropertyCustomColumn(customColumn, tagById, idx);
                if (propertyCol) {
                    cc_1.push(propertyCol);
                }
            }
            else if (customColumn.type === CustomColumnType.Table) {
                var tag = customColumn.tableTagId ? tagById[customColumn.tableTagId] : null;
                if (tag) {
                    cc_1.push(createTableCustomColumn(tag, tagsByParentId, idx, customColumn.readonly, (_a = customColumn.name) !== null && _a !== void 0 ? _a : undefined));
                }
            }
            else if (customColumn.type === CustomColumnType.Number) {
                cc_1.push(createNumberCustomColumn(customColumn, tagById, idx));
            }
        });
        return cc_1;
    }
    // custom timeline is on (some version is selected for some year)
    // -> add a custom column with every selected version
    var generatedCustomColHeaders = [];
    for (var idx = 0; idx < customColumns.length; idx++) {
        var customColumn = customColumns[idx];
        if (customColumn === undefined) {
            continue;
        }
        if (customColumn.type === CustomColumnType.Number) {
            if ((_b = customColumn.dimensionTagIds) === null || _b === void 0 ? void 0 : _b.some(function (tagId) { return activeVersionsTagIds.includes(tagId); })) {
                // custom column already has a version tag
                generatedCustomColHeaders.push(createNumberCustomColumn(customColumn, tagById, idx));
            }
            else {
                try {
                    // custom column has no version tag -> add a custom column with every active version
                    for (var filteredVersions_1 = (e_20 = void 0, __values(filteredVersions)), filteredVersions_1_1 = filteredVersions_1.next(); !filteredVersions_1_1.done; filteredVersions_1_1 = filteredVersions_1.next()) {
                        var version = filteredVersions_1_1.value;
                        generatedCustomColHeaders.push(createNumberCustomColumn(customColumn, tagById, idx, version));
                    }
                }
                catch (e_20_1) { e_20 = { error: e_20_1 }; }
                finally {
                    try {
                        if (filteredVersions_1_1 && !filteredVersions_1_1.done && (_a = filteredVersions_1.return)) _a.call(filteredVersions_1);
                    }
                    finally { if (e_20) throw e_20.error; }
                }
            }
        }
        else if (customColumn.type === CustomColumnType.Table && customColumn.property !== undefined) {
            var propertyCol = createPropertyCustomColumn(customColumn, tagById, idx);
            if (propertyCol) {
                generatedCustomColHeaders.push(propertyCol);
            }
        }
        else if (customColumn.type === CustomColumnType.Table) {
            var tag = customColumn.tableTagId ? tagById[customColumn.tableTagId] : null;
            if (tag) {
                generatedCustomColHeaders.push(createTableCustomColumn(tag, tagsByParentId, idx, undefined, (_c = customColumn.name) !== null && _c !== void 0 ? _c : undefined));
            }
        }
    }
    return generatedCustomColHeaders;
}
// columns:
export function generateModelTableColumns(intervalStart, intervalEnd, periods, showSum, versionsByYear, isStacked, isCustomDataDisplay, comparisons, diffFormat, versions, activeYears, monthTags, quarterTags, hyTags, yearTags, ytdTags) {
    var _a = parseInterval(intervalStart, intervalEnd, activeYears), startMonth = _a.startMonth, startYear = _a.startYear, endMonth = _a.endMonth, endYear = _a.endYear;
    var timelineOptions = {
        rollupPeriods: __spreadArray([], __read(periods), false),
        rollupType: RollupType.Sum,
        startMonth: startMonth,
        startYear: startYear,
        endMonth: endMonth,
        endYear: endYear,
        showSum: showSum,
    };
    var cols = [];
    if (isStacked) {
        cols = createStackedColumns(timelineOptions, monthTags, quarterTags, hyTags, ytdTags);
    }
    else if (isCustomDataDisplay) {
        cols = createCustomTimelineColumns(versionsByYear, comparisons, activeYears, timelineOptions, versions, diffFormat, monthTags, quarterTags, hyTags, yearTags, ytdTags);
    }
    else {
        cols = createBasicTimelineColumns(activeYears, timelineOptions, monthTags, quarterTags, hyTags, yearTags, ytdTags);
    }
    return cols;
}
var infix = '/';
function createStackedColumns(timelineOptions, monthTags, quarterTags, hyTags, ytdTags) {
    var cols = [];
    var mont = timelineOptions.rollupPeriods.indexOf('month') !== -1;
    var quarter = timelineOptions.rollupPeriods.indexOf('quarter') !== -1;
    var fullyear = timelineOptions.rollupPeriods.indexOf('year') !== -1;
    var half = timelineOptions.rollupPeriods.indexOf('halfyear') !== -1;
    var ytd = timelineOptions.rollupPeriods.indexOf('year to date') !== -1;
    var ms = 1;
    var me = 12;
    var _loop_4 = function (month) {
        var monthTag = monthTags.find(function (mt) { return mt.name === "M".concat(month); });
        if (mont && monthTag) {
            cols.push({
                dataString: getDataString([monthTag.id]),
                title: getTimeDimensionName(monthTag),
                type: ModelColumns.MONTH,
            });
        }
        if (ytd) {
            var ytdTag = ytdTags.find(function (t) { return t.order === month; });
            if (ytdTag) {
                cols.push({
                    dataString: getDataString([ytdTag.id]),
                    title: getTimeDimensionName(ytdTag),
                    type: ModelColumns.YEAR_TO_DATE,
                });
            }
        }
        if (quarter && month % 3 === 0) {
            var num_1 = Math.floor((month - 1) / 3) + 1;
            var quarterTag = quarterTags.find(function (qt) { return qt.name === "Q".concat(num_1); });
            quarterTag &&
                cols.push({
                    dataString: getDataString([quarterTag.id]),
                    title: getTimeDimensionName(quarterTag),
                    type: ModelColumns.QUARTER,
                });
        }
        if (half && month % 6 === 0) {
            var num_2 = Math.floor((month - 1) / 6) + 1;
            var hyTag = hyTags.find(function (hyt) { return hyt.name === "H".concat(num_2); });
            hyTag &&
                cols.push({
                    dataString: getDataString([hyTag.id]),
                    title: getTimeDimensionName(hyTag),
                    type: ModelColumns.HALFYEAR,
                });
        }
        if (fullyear && month === 12) {
            cols.push({
                dataString: getDataString([]),
                title: 'Year',
                type: ModelColumns.YEAR,
            });
        }
    };
    for (var month = ms; month <= me; month++) {
        _loop_4(month);
    }
    if (timelineOptions.showSum) {
        var monthIds = [];
        var _loop_5 = function (month) {
            var monthTag = monthTags.find(function (mt) { return mt.name === "M".concat(month); });
            if (monthTag)
                monthIds.push(monthTag.id);
        };
        for (var month = ms; month <= me; month++) {
            _loop_5(month);
        }
        cols.push({
            dataString: getDataString([monthIds]),
            title: 'Σ',
            type: ModelColumns.SUM,
        });
    }
    return cols;
}
function createBasicTimelineColumns(activeYears, timelineOptions, monthTags, quarterTags, hyTags, yearTags, ytdTags) {
    var e_21, _a, e_22, _b;
    var cols = [];
    var startMonth = timelineOptions.startMonth, startYear = timelineOptions.startYear, endMonth = timelineOptions.endMonth, endYear = timelineOptions.endYear, rollupPeriods = timelineOptions.rollupPeriods;
    var hasMonth = rollupPeriods.includes(Period.MONTH);
    var hasQuarter = rollupPeriods.includes(Period.QUARTER);
    var hasHalfYear = rollupPeriods.includes(Period.HALFYEAR);
    var hasFullYear = rollupPeriods.includes(Period.YEAR);
    var hasYearToDate = rollupPeriods.includes(Period.YEAR_TO_DATE);
    var _loop_6 = function (y) {
        if (y < startYear || y > endYear) {
            return "continue";
        }
        var thisYearMonthStart = startYear === y ? startMonth : 1;
        var thisYearMonthEnd = endYear === y ? endMonth : 12;
        var yearTag = yearTags.find(function (yt) { return yt.name === "Y".concat(y); });
        if (!yearTag) {
            return "continue";
        }
        var usedMonths = [];
        var _loop_8 = function (month) {
            var thisMonthInInterval = month >= thisYearMonthStart && month <= thisYearMonthEnd;
            if (thisMonthInInterval) {
                usedMonths.push(month);
            }
            var monthTag = monthTags.find(function (mt) { return mt.name === "M".concat(month); });
            if (hasMonth && monthTag && thisMonthInInterval) {
                cols.push({
                    dataString: getDataString([yearTag.id, monthTag.id]),
                    title: "".concat(getTimeDimensionName(monthTag)).concat(infix).concat(getTimeDimensionName(yearTag)),
                    type: ModelColumns.MONTH,
                });
            }
            if (hasYearToDate && thisMonthInInterval) {
                var ytdTag = ytdTags.find(function (t) { return t.order === month; });
                if (ytdTag) {
                    cols.push({
                        dataString: getDataString([yearTag.id, ytdTag.id]),
                        title: "".concat(getTimeDimensionName(ytdTag)).concat(infix).concat(getTimeDimensionName(yearTag)),
                        type: ModelColumns.YEAR_TO_DATE,
                    });
                }
            }
            if (hasQuarter && month % 3 === 0 && usedMonths.some(function (m) { return m >= month - 2 && m <= month; })) {
                var num_3 = Math.floor((month - 1) / 3) + 1;
                var quarterTag = quarterTags.find(function (qt) { return qt.name === "Q".concat(num_3); });
                quarterTag &&
                    cols.push({
                        dataString: getDataString([yearTag.id, quarterTag.id]),
                        title: "".concat(getTimeDimensionName(quarterTag)).concat(infix).concat(getTimeDimensionName(yearTag)),
                        type: ModelColumns.QUARTER,
                    });
            }
            if (hasHalfYear && month % 6 === 0 && usedMonths.some(function (m) { return m >= month - 5 && m <= month; })) {
                var num_4 = Math.floor((month - 1) / 6) + 1;
                var hyTag = hyTags.find(function (hyt) { return hyt.name === "H".concat(num_4); });
                hyTag &&
                    cols.push({
                        dataString: getDataString([yearTag.id, hyTag.id]),
                        title: "".concat(getTimeDimensionName(hyTag)).concat(infix).concat(getTimeDimensionName(yearTag)),
                        type: ModelColumns.HALFYEAR,
                    });
            }
        };
        for (var month = 1; month <= 12; month++) {
            _loop_8(month);
        }
        if (hasFullYear && usedMonths.length > 0) {
            cols.push({
                dataString: getDataString([yearTag.id]),
                title: "".concat(getTimeDimensionName(yearTag)),
                type: ModelColumns.YEAR,
            });
        }
    };
    try {
        for (var activeYears_3 = __values(activeYears), activeYears_3_1 = activeYears_3.next(); !activeYears_3_1.done; activeYears_3_1 = activeYears_3.next()) {
            var y = activeYears_3_1.value;
            _loop_6(y);
        }
    }
    catch (e_21_1) { e_21 = { error: e_21_1 }; }
    finally {
        try {
            if (activeYears_3_1 && !activeYears_3_1.done && (_a = activeYears_3.return)) _a.call(activeYears_3);
        }
        finally { if (e_21) throw e_21.error; }
    }
    if (timelineOptions.showSum) {
        var ds = [];
        var _loop_7 = function (y) {
            if (y < startYear || y > endYear) {
                return "continue";
            }
            var thisYearMonthStart = startYear === y ? startMonth : 1;
            var thisYearMonthEnd = endYear === y ? endMonth : 12;
            var yearTag = yearTags.find(function (yt) { return yt.name === "Y".concat(y); });
            if (!yearTag) {
                return "continue";
            }
            var monthTagIds = [];
            var _loop_9 = function (month) {
                var monthTag = monthTags.find(function (mt) { return mt.name === "M".concat(month); });
                monthTag && monthTagIds.push(monthTag.id);
            };
            for (var month = thisYearMonthStart; month <= thisYearMonthEnd; month++) {
                _loop_9(month);
            }
            if (monthTagIds.length > 0) {
                ds.push(getDataString([yearTag.id, monthTagIds.sort(function (a, b) { return a - b; })]));
            }
        };
        try {
            for (var activeYears_4 = __values(activeYears), activeYears_4_1 = activeYears_4.next(); !activeYears_4_1.done; activeYears_4_1 = activeYears_4.next()) {
                var y = activeYears_4_1.value;
                _loop_7(y);
            }
        }
        catch (e_22_1) { e_22 = { error: e_22_1 }; }
        finally {
            try {
                if (activeYears_4_1 && !activeYears_4_1.done && (_b = activeYears_4.return)) _b.call(activeYears_4);
            }
            finally { if (e_22) throw e_22.error; }
        }
        cols.push({
            dataString: ds.join('+'),
            title: 'Σ',
            type: ModelColumns.SUM,
        });
    }
    return cols;
}
function createCustomTimelineColumns(versionsByYear, comparisons, activeYears, timelineOptions, versions, diffFormat, monthTags, quarterTags, hyTags, yearTags, ytdTags) {
    var e_23, _a, e_24, _b, e_25, _c, e_26, _d;
    var _e, _f, _g, _h, _j, _k, _l;
    var columns = [];
    var startMonth = timelineOptions.startMonth, startYear = timelineOptions.startYear, endMonth = timelineOptions.endMonth, endYear = timelineOptions.endYear, rollupPeriods = timelineOptions.rollupPeriods;
    var hasMonth = rollupPeriods.includes(Period.MONTH);
    var hasQuarter = rollupPeriods.includes(Period.QUARTER);
    var hasHalfYear = rollupPeriods.includes(Period.HALFYEAR);
    var hasFullYear = rollupPeriods.includes(Period.YEAR);
    var hasYearToDate = rollupPeriods.includes(Period.YEAR_TO_DATE);
    var versionsById = {};
    try {
        for (var versions_1 = __values(versions), versions_1_1 = versions_1.next(); !versions_1_1.done; versions_1_1 = versions_1.next()) {
            var v = versions_1_1.value;
            versionsById[v.id] = v;
        }
    }
    catch (e_23_1) { e_23 = { error: e_23_1 }; }
    finally {
        try {
            if (versions_1_1 && !versions_1_1.done && (_a = versions_1.return)) _a.call(versions_1);
        }
        finally { if (e_23) throw e_23.error; }
    }
    var _loop_10 = function (y) {
        var e_27, _m, e_28, _o, e_29, _p;
        if (y < startYear || y > endYear) {
            return "continue";
        }
        var thisYearMonthStart = startYear === y ? startMonth : 1;
        var thisYearMonthEnd = endYear === y ? endMonth : 12;
        var vIdsForYear = versionsByYear[y];
        // temp removal of 'None' version
        if (vIdsForYear === null || vIdsForYear === void 0 ? void 0 : vIdsForYear.includes(0)) {
            vIdsForYear = vIdsForYear.filter(function (vId) { return vId !== 0; });
        }
        var yearTag = yearTags.find(function (yt) { return yt.name === "Y".concat(y); });
        if (!yearTag) {
            return "continue";
        }
        if (vIdsForYear && vIdsForYear.length > 0) {
            var filteredComparisons = [];
            try {
                for (var comparisons_2 = (e_27 = void 0, __values(comparisons)), comparisons_2_1 = comparisons_2.next(); !comparisons_2_1.done; comparisons_2_1 = comparisons_2.next()) {
                    var comparison = comparisons_2_1.value;
                    var maxYear = Math.max(comparison.optionA.year, comparison.optionB.year);
                    var optionAExist = versionsByYear[comparison.optionA.year] &&
                        comparison.optionA.year >= startYear &&
                        comparison.optionA.year <= endYear
                        ? (_e = versionsByYear === null || versionsByYear === void 0 ? void 0 : versionsByYear[comparison.optionA.year]) === null || _e === void 0 ? void 0 : _e.includes(comparison.optionA.versionId)
                        : false;
                    var optionBExist = versionsByYear[comparison.optionB.year] &&
                        comparison.optionB.year >= startYear &&
                        comparison.optionB.year <= endYear
                        ? (_f = versionsByYear === null || versionsByYear === void 0 ? void 0 : versionsByYear[comparison.optionB.year]) === null || _f === void 0 ? void 0 : _f.includes(comparison.optionB.versionId)
                        : false;
                    if (maxYear === y && optionAExist && optionBExist) {
                        filteredComparisons.push(comparison);
                    }
                }
            }
            catch (e_27_1) { e_27 = { error: e_27_1 }; }
            finally {
                try {
                    if (comparisons_2_1 && !comparisons_2_1.done && (_m = comparisons_2.return)) _m.call(comparisons_2);
                }
                finally { if (e_27) throw e_27.error; }
            }
            var usedMonths = [];
            var _loop_12 = function (month) {
                var e_30, _q, e_31, _r, e_32, _s, e_33, _t, e_34, _u, e_35, _v, e_36, _w, e_37, _x;
                var thisMonthInInterval = month >= thisYearMonthStart && month <= thisYearMonthEnd;
                if (thisMonthInInterval) {
                    usedMonths.push(month);
                }
                var monthTag = monthTags.find(function (mt) { return mt.name === "M".concat(month); });
                if (hasMonth && monthTag && thisMonthInInterval) {
                    try {
                        for (var vIdsForYear_2 = (e_30 = void 0, __values(vIdsForYear)), vIdsForYear_2_1 = vIdsForYear_2.next(); !vIdsForYear_2_1.done; vIdsForYear_2_1 = vIdsForYear_2.next()) {
                            var vId = vIdsForYear_2_1.value;
                            var vTagId = getVersionTagId(vId, versions);
                            columns.push({
                                dataString: getDataString([yearTag.id, monthTag.id, vTagId]),
                                title: "".concat(getTimeDimensionName(monthTag)).concat(infix).concat(getTimeDimensionName(yearTag), " ").concat(((_g = versionsById[vId]) === null || _g === void 0 ? void 0 : _g.name) || ''),
                                type: ModelColumns.MONTH,
                            });
                        }
                    }
                    catch (e_30_1) { e_30 = { error: e_30_1 }; }
                    finally {
                        try {
                            if (vIdsForYear_2_1 && !vIdsForYear_2_1.done && (_q = vIdsForYear_2.return)) _q.call(vIdsForYear_2);
                        }
                        finally { if (e_30) throw e_30.error; }
                    }
                    try {
                        for (var filteredComparisons_3 = (e_31 = void 0, __values(filteredComparisons)), filteredComparisons_3_1 = filteredComparisons_3.next(); !filteredComparisons_3_1.done; filteredComparisons_3_1 = filteredComparisons_3.next()) {
                            var comparison = filteredComparisons_3_1.value;
                            columns.push.apply(columns, __spreadArray([], __read(getComparisonDataArray(comparison, yearTags, diffFormat, versions, [monthTag.id], "".concat(getTimeDimensionName(monthTag)).concat(infix))), false));
                        }
                    }
                    catch (e_31_1) { e_31 = { error: e_31_1 }; }
                    finally {
                        try {
                            if (filteredComparisons_3_1 && !filteredComparisons_3_1.done && (_r = filteredComparisons_3.return)) _r.call(filteredComparisons_3);
                        }
                        finally { if (e_31) throw e_31.error; }
                    }
                }
                var ytdTag = ytdTags.find(function (t) { return t.order === month; });
                if (hasYearToDate && ytdTag && thisMonthInInterval) {
                    try {
                        for (var vIdsForYear_3 = (e_32 = void 0, __values(vIdsForYear)), vIdsForYear_3_1 = vIdsForYear_3.next(); !vIdsForYear_3_1.done; vIdsForYear_3_1 = vIdsForYear_3.next()) {
                            var vId = vIdsForYear_3_1.value;
                            var vTagId = getVersionTagId(vId, versions);
                            columns.push({
                                dataString: getDataString([yearTag.id, ytdTag.id, vTagId]),
                                title: "".concat(getTimeDimensionName(ytdTag)).concat(infix).concat(getTimeDimensionName(yearTag), " ").concat(((_h = versionsById[vId]) === null || _h === void 0 ? void 0 : _h.name) || ''),
                                type: ModelColumns.YEAR_TO_DATE,
                            });
                        }
                    }
                    catch (e_32_1) { e_32 = { error: e_32_1 }; }
                    finally {
                        try {
                            if (vIdsForYear_3_1 && !vIdsForYear_3_1.done && (_s = vIdsForYear_3.return)) _s.call(vIdsForYear_3);
                        }
                        finally { if (e_32) throw e_32.error; }
                    }
                    try {
                        for (var filteredComparisons_4 = (e_33 = void 0, __values(filteredComparisons)), filteredComparisons_4_1 = filteredComparisons_4.next(); !filteredComparisons_4_1.done; filteredComparisons_4_1 = filteredComparisons_4.next()) {
                            var comparison = filteredComparisons_4_1.value;
                            columns.push.apply(columns, __spreadArray([], __read(getComparisonDataArray(comparison, yearTags, diffFormat, versions, [ytdTag.id], "".concat(getTimeDimensionName(ytdTag)).concat(infix))), false));
                        }
                    }
                    catch (e_33_1) { e_33 = { error: e_33_1 }; }
                    finally {
                        try {
                            if (filteredComparisons_4_1 && !filteredComparisons_4_1.done && (_t = filteredComparisons_4.return)) _t.call(filteredComparisons_4);
                        }
                        finally { if (e_33) throw e_33.error; }
                    }
                }
                if (hasQuarter && month % 3 === 0 && usedMonths.some(function (m) { return m >= month - 2 && m <= month; })) {
                    var num_5 = Math.floor((month - 1) / 3) + 1;
                    var quarterTag = quarterTags.find(function (qt) { return qt.name === "Q".concat(num_5); });
                    if (quarterTag) {
                        try {
                            for (var vIdsForYear_4 = (e_34 = void 0, __values(vIdsForYear)), vIdsForYear_4_1 = vIdsForYear_4.next(); !vIdsForYear_4_1.done; vIdsForYear_4_1 = vIdsForYear_4.next()) {
                                var vId = vIdsForYear_4_1.value;
                                var vTagId = getVersionTagId(vId, versions);
                                columns.push({
                                    dataString: getDataString([yearTag.id, quarterTag.id, vTagId]),
                                    title: "".concat(getTimeDimensionName(quarterTag)).concat(infix).concat(getTimeDimensionName(yearTag), " ").concat(((_j = versionsById[vId]) === null || _j === void 0 ? void 0 : _j.name) || ''),
                                    type: ModelColumns.QUARTER,
                                });
                            }
                        }
                        catch (e_34_1) { e_34 = { error: e_34_1 }; }
                        finally {
                            try {
                                if (vIdsForYear_4_1 && !vIdsForYear_4_1.done && (_u = vIdsForYear_4.return)) _u.call(vIdsForYear_4);
                            }
                            finally { if (e_34) throw e_34.error; }
                        }
                        try {
                            for (var filteredComparisons_5 = (e_35 = void 0, __values(filteredComparisons)), filteredComparisons_5_1 = filteredComparisons_5.next(); !filteredComparisons_5_1.done; filteredComparisons_5_1 = filteredComparisons_5.next()) {
                                var comparison = filteredComparisons_5_1.value;
                                columns.push.apply(columns, __spreadArray([], __read(getComparisonDataArray(comparison, yearTags, diffFormat, versions, [quarterTag.id], "".concat(getTimeDimensionName(quarterTag)).concat(infix))), false));
                            }
                        }
                        catch (e_35_1) { e_35 = { error: e_35_1 }; }
                        finally {
                            try {
                                if (filteredComparisons_5_1 && !filteredComparisons_5_1.done && (_v = filteredComparisons_5.return)) _v.call(filteredComparisons_5);
                            }
                            finally { if (e_35) throw e_35.error; }
                        }
                    }
                }
                if (hasHalfYear && month % 6 === 0 && usedMonths.some(function (m) { return m >= month - 5 && m <= month; })) {
                    var num_6 = Math.floor((month - 1) / 6) + 1;
                    var hyTag = hyTags.find(function (hyt) { return hyt.name === "H".concat(num_6); });
                    if (hyTag) {
                        try {
                            for (var vIdsForYear_5 = (e_36 = void 0, __values(vIdsForYear)), vIdsForYear_5_1 = vIdsForYear_5.next(); !vIdsForYear_5_1.done; vIdsForYear_5_1 = vIdsForYear_5.next()) {
                                var vId = vIdsForYear_5_1.value;
                                var vTagId = getVersionTagId(vId, versions);
                                columns.push({
                                    dataString: getDataString([yearTag.id, hyTag.id, vTagId]),
                                    title: "".concat(getTimeDimensionName(hyTag)).concat(infix).concat(getTimeDimensionName(yearTag), " ").concat(((_k = versionsById[vId]) === null || _k === void 0 ? void 0 : _k.name) || ''),
                                    type: ModelColumns.HALFYEAR,
                                });
                            }
                        }
                        catch (e_36_1) { e_36 = { error: e_36_1 }; }
                        finally {
                            try {
                                if (vIdsForYear_5_1 && !vIdsForYear_5_1.done && (_w = vIdsForYear_5.return)) _w.call(vIdsForYear_5);
                            }
                            finally { if (e_36) throw e_36.error; }
                        }
                        try {
                            for (var filteredComparisons_6 = (e_37 = void 0, __values(filteredComparisons)), filteredComparisons_6_1 = filteredComparisons_6.next(); !filteredComparisons_6_1.done; filteredComparisons_6_1 = filteredComparisons_6.next()) {
                                var comparison = filteredComparisons_6_1.value;
                                columns.push.apply(columns, __spreadArray([], __read(getComparisonDataArray(comparison, yearTags, diffFormat, versions, [hyTag.id], "".concat(getTimeDimensionName(hyTag)).concat(infix))), false));
                            }
                        }
                        catch (e_37_1) { e_37 = { error: e_37_1 }; }
                        finally {
                            try {
                                if (filteredComparisons_6_1 && !filteredComparisons_6_1.done && (_x = filteredComparisons_6.return)) _x.call(filteredComparisons_6);
                            }
                            finally { if (e_37) throw e_37.error; }
                        }
                    }
                }
            };
            for (var month = 1; month <= 12; month++) {
                _loop_12(month);
            }
            if (hasFullYear && usedMonths.length > 0) {
                try {
                    for (var vIdsForYear_1 = (e_28 = void 0, __values(vIdsForYear)), vIdsForYear_1_1 = vIdsForYear_1.next(); !vIdsForYear_1_1.done; vIdsForYear_1_1 = vIdsForYear_1.next()) {
                        var vId = vIdsForYear_1_1.value;
                        var vTagId = getVersionTagId(vId, versions);
                        columns.push({
                            dataString: getDataString([yearTag.id, vTagId]),
                            title: "".concat(getTimeDimensionName(yearTag), " ").concat(((_l = versionsById[vId]) === null || _l === void 0 ? void 0 : _l.name) || ''),
                            type: ModelColumns.YEAR,
                        });
                    }
                }
                catch (e_28_1) { e_28 = { error: e_28_1 }; }
                finally {
                    try {
                        if (vIdsForYear_1_1 && !vIdsForYear_1_1.done && (_o = vIdsForYear_1.return)) _o.call(vIdsForYear_1);
                    }
                    finally { if (e_28) throw e_28.error; }
                }
                try {
                    for (var filteredComparisons_2 = (e_29 = void 0, __values(filteredComparisons)), filteredComparisons_2_1 = filteredComparisons_2.next(); !filteredComparisons_2_1.done; filteredComparisons_2_1 = filteredComparisons_2.next()) {
                        var comparison = filteredComparisons_2_1.value;
                        columns.push.apply(columns, __spreadArray([], __read(getComparisonDataArray(comparison, yearTags, diffFormat, versions, [])), false));
                    }
                }
                catch (e_29_1) { e_29 = { error: e_29_1 }; }
                finally {
                    try {
                        if (filteredComparisons_2_1 && !filteredComparisons_2_1.done && (_p = filteredComparisons_2.return)) _p.call(filteredComparisons_2);
                    }
                    finally { if (e_29) throw e_29.error; }
                }
            }
        }
    };
    try {
        for (var activeYears_5 = __values(activeYears), activeYears_5_1 = activeYears_5.next(); !activeYears_5_1.done; activeYears_5_1 = activeYears_5.next()) {
            var y = activeYears_5_1.value;
            _loop_10(y);
        }
    }
    catch (e_24_1) { e_24 = { error: e_24_1 }; }
    finally {
        try {
            if (activeYears_5_1 && !activeYears_5_1.done && (_b = activeYears_5.return)) _b.call(activeYears_5);
        }
        finally { if (e_24) throw e_24.error; }
    }
    if (timelineOptions.showSum) {
        try {
            for (var versions_2 = __values(versions), versions_2_1 = versions_2.next(); !versions_2_1.done; versions_2_1 = versions_2.next()) {
                var v = versions_2_1.value;
                var ds = [];
                var _loop_11 = function (y) {
                    if (y < startYear || y > endYear) {
                        return "continue";
                    }
                    var thisYearMonthStart = startYear === y ? startMonth : 1;
                    var thisYearMonthEnd = endYear === y ? endMonth : 12;
                    var vIdsForYear = versionsByYear[y];
                    var yearTag = yearTags.find(function (yt) { return yt.name === "Y".concat(y); });
                    if (!yearTag) {
                        return "continue";
                    }
                    if (vIdsForYear && vIdsForYear.includes(v.id)) {
                        var monthTagIds = [];
                        var _loop_13 = function (month) {
                            var monthTag = monthTags.find(function (mt) { return mt.name === "M".concat(month); });
                            if (monthTag) {
                                monthTagIds.push(monthTag.id);
                            }
                        };
                        for (var month = thisYearMonthStart; month <= thisYearMonthEnd; month++) {
                            _loop_13(month);
                        }
                        ds.push(getDataString([yearTag.id, monthTagIds, v.versionTagId]));
                    }
                };
                try {
                    for (var activeYears_6 = (e_26 = void 0, __values(activeYears)), activeYears_6_1 = activeYears_6.next(); !activeYears_6_1.done; activeYears_6_1 = activeYears_6.next()) {
                        var y = activeYears_6_1.value;
                        _loop_11(y);
                    }
                }
                catch (e_26_1) { e_26 = { error: e_26_1 }; }
                finally {
                    try {
                        if (activeYears_6_1 && !activeYears_6_1.done && (_d = activeYears_6.return)) _d.call(activeYears_6);
                    }
                    finally { if (e_26) throw e_26.error; }
                }
                if (ds.length > 0) {
                    columns.push({
                        dataString: ds.join('+'),
                        title: "\u03A3 ".concat(v.name),
                        type: ModelColumns.SUM,
                    });
                }
            }
        }
        catch (e_25_1) { e_25 = { error: e_25_1 }; }
        finally {
            try {
                if (versions_2_1 && !versions_2_1.done && (_c = versions_2.return)) _c.call(versions_2);
            }
            finally { if (e_25) throw e_25.error; }
        }
    }
    return columns;
}
// table rows
export function getTableRows(rowsHeaders, data, tagColumnsData, cellUpdatesInProgress, forecastErrors, tagById) {
    return rowsHeaders.map(function (rh, idx) {
        var _a, _b;
        var currRowTagData = tagColumnsData ? (_a = tagColumnsData[idx]) !== null && _a !== void 0 ? _a : [] : [];
        var currRowData = data && data[idx] ? data[idx] : [];
        var tableRowData = rh.object.isNoResult
            ? []
            : createTableRowData(currRowTagData, currRowData, idx, cellUpdatesInProgress);
        var rowTagIds = rh.dataString.replace('tags(', '').replace(')', '').split(',').map(Number);
        var rowTags = rowTagIds.map(function (tagId) { return tagById[tagId]; }).filter(function (t) { return t !== undefined; });
        var rowAccountTag = rowTags.find(function (tag) { return tag.type === TagType.Account; });
        var rowVersionTag = rowTags.find(function (tag) { return tag.internalType === InternalTagType.Version; });
        var rowForecastErrors = null;
        if (rowAccountTag !== undefined && rowAccountTag.dimensionTagIds !== undefined && rowVersionTag !== undefined) {
            var tagKeyIds = new Set(rowTags.filter(function (t) { var _a; return rowAccountTag.dimensionTagIds.includes((_a = t.ParentId) !== null && _a !== void 0 ? _a : 0); }).map(function (t) { return t.id; })); // use only tags that are children of dimension tags in account tag
            tagKeyIds.add(rowAccountTag.id);
            tagKeyIds.add(rowVersionTag.id);
            var tagKey = Array.from(tagKeyIds)
                .sort(function (a, b) { return a - b; }) // sort ids ascending
                .join(',');
            rowForecastErrors = (_b = forecastErrors[tagKey]) !== null && _b !== void 0 ? _b : null;
        }
        var row = {
            depth: rh.depth,
            title: rh.title,
            tagName: rh.tagName,
            tagDesc: rh.tagDesc,
            objectId: rh.object.sheetRow.id,
            data: tableRowData,
            canExpand: rh.canExpand,
            expanded: rh.expanded,
            selected: rh.selected,
            readonly: tableRowData.length === 0 || !!rh.readonly,
            forecastErrors: rowForecastErrors,
            path: rh.object.path,
            tagInfos: rh.object.allTags,
            versionTagId: rowVersionTag === null || rowVersionTag === void 0 ? void 0 : rowVersionTag.id,
            versionId: rh.version ? rh.version.id : null,
            generatedTagId: rh.object.generatedTagId,
            generatedTableTagId: rh.object.parentTagId || null,
            accTagHasTopDown: (rowAccountTag === null || rowAccountTag === void 0 ? void 0 : rowAccountTag.topDownEnabled) || false,
            isNoResult: rh.object.isNoResult || false,
        };
        return row;
    });
}
function createTableRowData(tagCells, cells, y, cellUpdatesInProgress) {
    return cells.map(function (cell, idx) {
        var cellData = tagCells[idx]
            ? tagCells[idx]
            : cell;
        // check if cell is currently updating
        if (cellUpdatesInProgress.size > 0) {
            var key = cell.tagIds.join(',');
            var c = cellUpdatesInProgress.get(key);
            if (c !== undefined) {
                return __assign(__assign({}, cellData), { value: c, loading: true, position: { x: idx, y: y } });
            }
        }
        return __assign(__assign({}, cellData), { loading: false, position: { x: idx, y: y } });
    });
}
function sortTableRows(sortByColIdx, col, versionId, asc, modelTableRows) {
    if (typeof sortByColIdx !== 'number' || modelTableRows.length === 0) {
        return modelTableRows;
    }
    var rootClusterParentPath = modelTableRows[0].path.split('_').slice(0, -1).join('_');
    var byParentByPath = {};
    modelTableRows.forEach(function (row) {
        var _a;
        var parentPath = row.path.split('_').slice(0, -1).join('_');
        if (byParentByPath[parentPath]) {
            if (byParentByPath[parentPath][row.path]) {
                byParentByPath[parentPath][row.path].push(row);
            }
            else {
                byParentByPath[parentPath][row.path] = [row];
            }
        }
        else {
            byParentByPath[parentPath] = (_a = {}, _a[row.path] = [row], _a);
        }
    });
    var hasVersion = typeof versionId === 'number';
    var sortedData = [];
    function sort(children) {
        var sortedChildren = Object.keys(children).map(function (key) { return children[key]; });
        sortedChildren = sortedChildren.sort(function (a, b) {
            var _a, _b, _c, _d;
            var aByVersion = hasVersion ? a.find(function (cls) { return cls.versionId === versionId; }) : a[0];
            var bByVersion = hasVersion ? b.find(function (cls) { return cls.versionId === versionId; }) : b[0];
            var aValue = 0;
            var bValue = 0;
            if (col.type === ModelColumns.TITLE) {
                aValue = (aByVersion === null || aByVersion === void 0 ? void 0 : aByVersion.title) || '';
                bValue = (bByVersion === null || bByVersion === void 0 ? void 0 : bByVersion.title) || '';
            }
            else if (col.type === ModelColumns.DESCRIPTION) {
                aValue = (aByVersion === null || aByVersion === void 0 ? void 0 : aByVersion.tagDesc) || '';
                bValue = (bByVersion === null || bByVersion === void 0 ? void 0 : bByVersion.tagDesc) || '';
            }
            else if (col.type === ModelColumns.TAGS) {
                aValue = ((_a = aByVersion === null || aByVersion === void 0 ? void 0 : aByVersion.data[sortByColIdx]) === null || _a === void 0 ? void 0 : _a.tagName) || '';
                bValue = ((_b = bByVersion === null || bByVersion === void 0 ? void 0 : bByVersion.data[sortByColIdx]) === null || _b === void 0 ? void 0 : _b.tagName) || '';
            }
            else {
                aValue = ((_c = aByVersion === null || aByVersion === void 0 ? void 0 : aByVersion.data[sortByColIdx]) === null || _c === void 0 ? void 0 : _c.value) || 0;
                bValue = ((_d = bByVersion === null || bByVersion === void 0 ? void 0 : bByVersion.data[sortByColIdx]) === null || _d === void 0 ? void 0 : _d.value) || 0;
            }
            return asc ? (aValue < bValue ? -1 : 1) : bValue > aValue ? 1 : -1;
        });
        sortedChildren.forEach(function (child) {
            child.forEach(function (ch) {
                sortedData.push(ch);
            });
            if (byParentByPath[child[0].path]) {
                sort(byParentByPath[child[0].path]);
            }
        });
    }
    sort(byParentByPath[rootClusterParentPath]);
    return sortedData;
}
